import { type ReactElement, type ReactNode } from 'react';
import cx from 'clsx';

import './styles.scss';

type SubheadProps = Readonly<{
  secondary?: boolean;
  children?: ReactNode;
  actions?: Array<ReactElement<{}>>;
}>;

export const Subhead = ({ actions, children, secondary }: SubheadProps) => (
  <div className={cx('Subhead', { 'Subhead-secondary': secondary })}>
    <div className="Subhead-heading">{children}</div>
    {actions && actions.length && <div className="Subhead-actions">{actions}</div>}
  </div>
);
